import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux"; 
import { logout } from "../redux/authSlice"; 

function Logout() {
  const dispatch = useDispatch(); 
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(logout()); 
    navigate("/"); 
  }, [logout, navigate]);

  return (
    <div>
      <h2>Logging out...</h2>
    </div>
  );
}

export default Logout;
